import React, { SetStateAction, useMemo, useState } from "react"
import { ComparaisonMode } from "./ComparaisonMode"
import { Children } from "../../../../../../../components/miscellianous/children"

export const ComparaisonModeContext = React.createContext<ComparaisonModeStore>({} as ComparaisonModeStore)

export function ComparaisonModeContextProvider({ children }: Readonly<Children>): React.JSX.Element {
  const [comparaisonMode, setComparaisonMode] = useState<ComparaisonMode>(ComparaisonMode.LOT)

  const comparaisonModeStore: ComparaisonModeStore = useMemo(
    () => ({
      comparaisonMode,
      setComparaisonMode,
    }),
    [comparaisonMode]
  )
  return <ComparaisonModeContext.Provider value={comparaisonModeStore}>{children}</ComparaisonModeContext.Provider>
}

export interface ComparaisonModeStore {
  comparaisonMode: ComparaisonMode
  setComparaisonMode: React.Dispatch<SetStateAction<ComparaisonMode>>
}
